module.exports = __webpack_public_path__ + "img/add-icon.5c6c43ab.svg";